import { createStore } from "vuex";

export default createStore({
  state: {
    user: null,
    menuOpen: false,
    prevRoute: "",
    adminMenuOpen: true,
  },
  mutations: {
    setUser(state, val) {
      state.user = val;
    },
    setMenuOpen(state, val) {
      state.menuOpen = val;
    },
    setPrevRoute(state, val) {
      state.prevRoute = val;
    },
    toggleAdminMenuOpen(state) {
      state.adminMenuOpen = !state.adminMenuOpen;
    },
  },
});
